import '../../styles/pages/about.scss';

document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.about__accordion-head');
    const accordionItems = document.querySelectorAll('.about__accordion-item');
    const accodionBodies = document.querySelectorAll('.about__accordion-body');

    triggers.forEach((item, i) => {
        item.addEventListener('click', () => {
            accodionBodies[i].classList.toggle('about-hidden');
            accordionItems[i].classList.toggle('about__accordion-active');
        })
    })
});